import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, FormControl, FormHelperText, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CardUploadImagem } from "../../../core/components/CardUploadImagem";
import { useCadastrarEditarProdutoContext } from "../../contexts/CadastrarEditarProdutoContext";
import { IImagemProduto } from "../../interfaces/IImagemProduto";
import { preparadoSchema } from "../../schema/preparadoSchema";
import { ImagemContainer } from "../ConfiguracaoPizzaContainer/styles";
import { ButtonsContainerForm, ConfiguracaoContainer, Formulario, FormularioPaper } from "../ConfiguracaoPreparadoContainer/styles";

export const ConfiguracaoComboContainer = () => {
    const [imagem, setImagem] = useState<undefined | File | IImagemProduto>(undefined);

    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "onChange",
        resolver: yupResolver(preparadoSchema)
    });

    const {
        handleExcluirImagem,
        handleUploadImagem,
        descricao,
        preco,
        detalhes,
        registrarConfiguracaoCombo,
        setDescricao,
        setPreco,
        setDetalhes,
        setServe,
        serve,
        imagens,
        precoSemDesconto,
        setPrecoSemDesconto,
        handleVoltar,
    } = useCadastrarEditarProdutoContext();

    useEffect(() => {
        if (imagens?.length) {
            setImagem(imagens[0]);
        } else {
            setImagem(undefined);
        }
    }, [imagens]);

    return (
        <ConfiguracaoContainer>
            <FormularioPaper onSubmit={handleSubmit(registrarConfiguracaoCombo)}>
                <Formulario>
                    <Typography variant="h6" sx={{ width: "100%", marginBottom: "1rem" }}>
                        Configuração
                    </Typography>
                    <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                        <TextField
                            label="Nome"
                            {...register("descricao")}
                            onChange={(e) => setDescricao(e.target.value)}
                            value={descricao}
                            error={!!errors.descricao}
                            helperText={<>{errors.descricao?.message}</>}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Ex: Combo Família, Combo Pizza + Bebida..."
                        />
                    </FormControl>
                    <FormControl sx={{ marginTop: "1.5rem" }} fullWidth>
                        <InputLabel error={!!errors.preco} htmlFor="preco-combo">Preço base</InputLabel>
                        <OutlinedInput
                            id="preco-combo"
                            startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                            label="Preço base"
                            error={!!errors.preco}
                            value={preco}
                            {...register('preco')}
                            placeholder="Preço base do combo"
                            onChange={(e) => setPreco(e.target.value)}
                        />
                        {!!errors.preco && <FormHelperText error><>{errors.preco?.message}</></FormHelperText>}
                    </FormControl>
                    <FormControl sx={{ marginTop: "1.5rem" }} fullWidth>
                        <InputLabel error={!!errors.precoSemDesconto} htmlFor="preco-sem-desconto-combo">Preço sem desconto</InputLabel>
                        <OutlinedInput
                            id="preco-sem-desconto-combo"
                            startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                            label="Preço sem desconto"
                            error={!!errors.precoSemDesconto}
                            value={precoSemDesconto}
                            {...register('precoSemDesconto')}
                            placeholder="Preço sem desconto"
                            onChange={(e) => setPrecoSemDesconto(e.target.value)}
                        />
                        {!!errors.precoSemDesconto && <FormHelperText error><>{errors.precoSemDesconto?.message}</></FormHelperText>}
                    </FormControl>
                    <FormControl sx={{ marginTop: "1.5rem" }} fullWidth>
                        <InputLabel htmlFor="serve-combo-select">Quantidade de pessoas servidas</InputLabel>
                        <Select
                            labelId="serve-combo-select"
                            id="serve-combo-select"
                            value={serve ?? 0}
                            onChange={(e) => setServe(e.target.value == undefined ? undefined : Number(e.target.value))}
                            label="Quantidade de pessoas servidas"
                        >
                            <MenuItem value={0}><em>Não aplicável</em></MenuItem>
                            {[1, 2, 3, 4].map((option) => (
                                <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ marginTop: "1.5rem" }} fullWidth>
                        <TextField
                            multiline
                            label="Detalhes"
                            {...register("detalhes")}
                            value={detalhes}
                            error={!!errors.detalhes}
                            helperText={<>{errors.detalhes?.message}</>}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Ex: Combo com pizza grande + 2 refrigerantes..."
                            onChange={(e) => setDetalhes(e.target.value)}
                            minRows={3}
                            maxRows={12}
                        />
                    </FormControl>
                    <ImagemContainer>
                        <CardUploadImagem
                            titulo="Imagem"
                            descricao={
                                imagem
                                    ? (imagem instanceof File ? imagem?.name : (imagem?.nomeOriginal ?? imagem?.nome))
                                    : "Faça o upload"
                            }
                            url={imagem instanceof File ? URL.createObjectURL(imagem) : imagem?.url}
                            excluir={handleExcluirImagem}
                            upload={handleUploadImagem}
                        />
                    </ImagemContainer>
                    <ButtonsContainerForm>
                        <Button size="medium" variant="outlined" type="button" onClick={handleVoltar}>
                            Voltar
                        </Button>
                        <Button size="medium" variant="contained" type="submit">
                            Próximo
                        </Button>
                    </ButtonsContainerForm>
                </Formulario>
            </FormularioPaper>
        </ConfiguracaoContainer>
    );
};
